/**
 * @module FE-CU43_緊急連絡先設定画面-同居家族情報
 */
import AlsokPanel from './components/AlsokPanel.vue';
import AddFamilyModal from './components/modals/AddFamilyModal.vue';
import EditFamilyModal from './components/modals/EditFamilyModal.vue';
import DeleteConfirmModal from './components/modals/DeleteConfirmModal.vue';
import Draggable from 'vuedraggable';
import CONSTANTS from '../../../constants';
import { relationship } from './computed';

const PAGE_ID = 'FE-CU43';

export default {
  name: 'EmergencyContactFamilyMembersPage',
  components: {
    AlsokPanel,
    AddFamilyModal,
    EditFamilyModal,
    DeleteConfirmModal,
    Draggable,
  },
  filters: {
    formatDate: function (date) {
      if (!date ?? true) {
        return '';
      }
      const year = date.substr(0, 4);
      const month = date.substr(5, 2);
      const day = date.substr(8, 2);
      return year + '/' + month + '/' + day;
    },
  },
  data(vm) {
    return {
      secretCode: '',
      secretCodeKana: '',
      displaySecretCode: '',
      displaySecretCodeKana: '',
      person: {
        name: '',
        nameKana: '',
        relationship: '',
        birthday: '',
      },
      // 画面と双方向バインディングする配列
      family: [],
      // 変更ボタン押下時に渡す配列(双方向バインディング用と別で定義しないと、変更ダイアログで修正した時にダイアログの後ろの項目も更新されていまう)
      copyFamily: [],
      // 並び替え完了時にDBに送信する配列
      setFamily: [],
      dialog: false,
      dialog2: false,
      valid: true,
      valid2: true,
      error: {
        hasSecretCodeKanaError: false,
        hasNameError: false,
        hasNameKanaError: false,
        hasRelationshipError: false,
        hasBirthdayError: false,
      },
      rules: {
        secretCodeKana: [
          // 両方入力 or 両方空白 (null) チェック
          () => this.secretCodeCheckRule,
          // 全角カナチェック
          (value) =>
            this.secretCode === '' ||
            /^[ァ-ヶー]+$/.test(value) ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0004'
            ),
        ],
        name: [],
        nameKana: [
          (value) =>
            !/^[ァ-ヶー]+$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0005'), //"氏名(カナ)は全角カタカナで入力してください。",
        ],
        relationship: [
          (value) =>
            !!value ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0012'
            ), // "続柄は必ず入力してください。"
        ],
        birthday: [
          (value) =>
            !!value ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0014'
            ), //"生年月日は必ず入力してください。"
        ],
      },
      appendAlertClass(hasError) {
        return { alert: hasError };
      },
      sortFlag: false,
      result: [],
      modified: '', // 登録時のmodifiedは、初期表示時にAPIで受け取った値を用いる
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    secretCodeCheckRule() {
      this.secretCode = this.secretCode === null ? '' : this.secretCode;
      this.secretCodeKana = this.secretCodeKana === null ? '' : this.secretCodeKana;
      if (
        (this.secretCode === '' && this.secretCodeKana !== '') ||
        (this.secretCode !== '' && this.secretCodeKana === '')
      ) {
        return this.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0018'
        );
      } else {
        return true;
      }
    },
    disabledSecretChangeButton() {
      return this.sortFlag;
    },
    i18nItems(vm) {
      return {
        panelTitle: vm.$vuetify.lang.t(
          '$vuetify.FECU43緊急連絡先設定画面同居家族情報.シークレットコード'
        ),
        panelInfo: vm.$vuetify.lang.t(
          '$vuetify.FECU43緊急連絡先設定画面同居家族情報.同居者様本人確認の際にお伺いいたします'
        ),
        relationship: relationship(vm),
      };
    },
    currentDisplayType() {
      return this.$store.state.currentDisplayType;
    },
    isDisabled() {
      if (!this.sortFlag) {
        if (this.family.length < CONSTANTS.REGISTRATION_LIMIT.FAMILY_MEMBERS_INFORMATION) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  beforMount() {
    this.$_setLoading(true);
  },
  async mounted() {
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    // 遷移元からtabIndexのパラメータを受け取った場合にタブを切り替える
    if (this.$route.params.tabIndex) {
      this.currentTab = this.$route.params.tabIndex;
    }

    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    //初期通信が遅いので、通信前に表示
    this.isShowPage = true;

    let method = 'post';

    // 遷移元のパラメータによって対象地区とカメラのどちらかのAPIを実行
    if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
      // APP_CU4301
      let param = '/api/emergencyContactFamilyMembers/getContactInfoDisplayDistrict';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
      };
      await this.APP_CU4301(param, queries, method);
    } else {
      // APP_CU4302
      let param = '/api/emergencyContactFamilyMembers/getContactInfoCamera';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
      };
      await this.APP_CU4302(param, queries, method);
    }
  },
  watch: {
    secretCode() {
      this.$nextTick(() => {
        this.$refs.form.validate();
      });
    },
    dialog(isOpened) {
      if (!isOpened) {
        this.closeSecretCodeModal();
      }
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 同居家族情報取得(表示地区)API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    APP_CU4301: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //     },
            //     secretCodeInfo: {
            //       secretCode: "あかさたな",
            //       secretCodeKana: "アカサタナ",
            //     },
            //     familyMembersList: [
            //       {
            //         familyMembersName: "山田花子",
            //         familyMembersKanaName: "ヤマダハナコ",
            //         familyMembersRelationship: 1,
            //         familyMembersRelationshipOther: "",
            //         familyMembersBirthdate: "1192-11-11",
            //       },
            //       {
            //         familyMembersName: "山田田中",
            //         familyMembersKanaName: "ヤマダタナカ",
            //         familyMembersRelationship: 2,
            //         familyMembersRelationshipOther: "",
            //         familyMembersBirthdate: "1999-11-22",
            //       },
            //       {
            //         familyMembersName: "田中太郎",
            //         familyMembersKanaName: "タナカタロウ",
            //         familyMembersRelationship: 14,
            //         familyMembersRelationshipOther: "",
            //         familyMembersBirthdate: "2015-03-03",
            //       },
            //       {
            //         familyMembersName: "testtest",
            //         familyMembersKanaName: "テスト",
            //         familyMembersRelationship: 2,
            //         familyMembersRelationshipOther: "",
            //         familyMembersBirthdate: "2022-07-07",
            //       },
            //       {
            //         familyMembersName: null,
            //         familyMembersKanaName: null,
            //         familyMembersRelationship: null,
            //         familyMembersRelationshipOther: null,
            //         familyMembersBirthdate: null,
            //       },
            //       {
            //         familyMembersName: null,
            //         familyMembersKanaName: null,
            //         familyMembersRelationship: null,
            //         familyMembersRelationshipOther: null,
            //         familyMembersBirthdate: null,
            //       },
            //       {
            //         familyMembersName: null,
            //         familyMembersKanaName: null,
            //         familyMembersRelationship: null,
            //         familyMembersRelationshipOther: null,
            //         familyMembersBirthdate: null,
            //       },
            //     ],
            //     modified: "2022-05-06 09:00:00",
            //   },
            // };

            // 同居家族リストの件数確認・マッピング
            this.checkFamilyMembersList(apiData.contentsInfo.familyMembersList);
            this.displaySecretCode = apiData.contentsInfo.secretCodeInfo.secretCode ?? '';
            this.displaySecretCodeKana = apiData.contentsInfo.secretCodeInfo.secretCodeKana ?? '';
            this.modified = apiData.contentsInfo.modified;

            const targetItem = apiData.contentsInfo.displayDistrictInfo;

            // ------- データ整形 ---------
            const labels = {
              usagePlan:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.対象地区詳細表示領域.利用プラン',
              customerNumber:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.対象地区詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.対象地区詳細表示領域.警備先名',
              districtSplitNumber:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.対象地区詳細表示領域.地区番号',
              districtSplitName:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.対象地区詳細表示領域.地区名',
              displayDistrictNickname: '',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
            ];
            const planTitles = {
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
            };
            // ListPanelコンポーネント用に整形
            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'displayDistrictNickname') {
                  return;
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU43緊急連絡先設定画面同居家族情報.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.result = [
                  ...this.result,
                  {
                    id: index,
                    title: labels[key],
                    text: text,
                    isVuetifyKey: text.includes('$'),
                  },
                ];
              }
            });

            this.family = this.family.filter((contact) => this.isExistFamilyMembers(contact));
            this.copyFamily = this.copyFamily.filter((contact) =>
              this.isExistFamilyMembers(contact)
            );
            this.setFamily = this.setFamily.filter((contact) => this.isExistFamilyMembers(contact));

            this.$emit('get-panel-data', {
              displayItems: this.result,
              title: {
                place: `${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
                type: '$vuetify.FECU27カメラ設定画面.対象地区',
                typeIsBefore: true,
              },
            });
          },
          (error) => {
            if (error.message.includes('500')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0020',
                false,
                false,
                '/sorry'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * 同居家族情報取得(カメラ)API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    APP_CU4302: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //       cameraNickName: "リビングカメラ",
            //       deviceID: "1111",
            //     },
            //     secretCodeInfo: {
            //       secretCode: "あかさたな",
            //       secretCodeKana: "アカサタナ",
            //     },
            //     familyMembersList: [
            //       {
            //         familyMembersName: "山田花子",
            //         familyMembersKanaName: "ヤマダハナコ",
            //         familyMembersRelationship: 1,
            //         familyMembersRelationshipOther: "",
            //         familyMembersBirthdate: "1192-11-11",
            //       },
            //       {
            //         familyMembersName: "山田田中",
            //         familyMembersKanaName: "ヤマダタナカ",
            //         familyMembersRelationship: 2,
            //         familyMembersRelationshipOther: "",
            //         familyMembersBirthdate: "1999-11-22",
            //       },
            //       {
            //         familyMembersName: "田中太郎",
            //         familyMembersKanaName: "タナカタロウ",
            //         familyMembersRelationship: 14,
            //         familyMembersRelationshipOther: "",
            //         familyMembersBirthdate: "2015-03-03",
            //       },
            //     ],
            //     modified: "2022-05-06 09:00:00",
            //   },
            // };

            // 同居家族リストの件数確認・マッピング
            this.checkFamilyMembersList(apiData.contentsInfo.familyMembersList);
            this.displaySecretCode = apiData.contentsInfo.secretCodeInfo?.secretCode ?? '';
            this.displaySecretCodeKana = apiData.contentsInfo.secretCodeInfo?.secretCodeKana ?? '';
            this.modified = apiData.contentsInfo.modified;

            const targetItem = apiData.contentsInfo.displayDistrictInfo;

            const labels = {
              usagePlan:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.カメラ詳細表示領域.利用プラン',
              customerNumber:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.カメラ詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.カメラ詳細表示領域.警備先名',
              districtSplitNumber:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.カメラ詳細表示領域.地区番号',
              districtSplitName:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.カメラ詳細表示領域.地区名',
              displayDistrictNickname:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.カメラ詳細表示領域.ニックネーム対象地区',
              deviceID:
                '$vuetify.FECU43緊急連絡先設定画面同居家族情報.カメラ詳細表示領域.デバイスID',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
              'deviceID',
            ];
            const planTitles = {
              [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
            };
            // ListPanelコンポーネント用に整形
            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU43緊急連絡先設定画面同居家族情報.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.result = [
                  ...this.result,
                  {
                    id: index,
                    title: labels[key],
                    text: text,
                    isVuetifyKey: text.includes('$'),
                  },
                ];
              }
            });

            this.family = this.family.filter((contact) => this.isExistFamilyMembers(contact));
            this.copyFamily = this.copyFamily.filter((contact) =>
              this.isExistFamilyMembers(contact)
            );
            this.setFamily = this.setFamily.filter((contact) => this.isExistFamilyMembers(contact));

            this.$emit('get-panel-data', {
              displayItems: this.result,
              title: {
                place: `${apiData.contentsInfo.displayDistrictInfo.cameraNickName}`,
                type: '$vuetify.FECU27カメラ設定画面.カメラ',
                typeIsBefore: true,
              },
            });
          },
          (error) => {
            if (error.message.includes('500')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0020',
                false,
                false,
                '/sorry'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * シークレットコード変更ダイアログ呼び出し時処理
     */
    openSecretCodeModal: function () {
      this.secretCode = this.displaySecretCode;
      this.secretCodeKana = this.displaySecretCodeKana;
    },
    /**
     * シークレットコード変更ダイアログ閉じる時処理
     */
    closeSecretCodeModal() {
      this.secretCode = this.displaySecretCode;
      this.secretCodeKana = this.displaySecretCodeKana;

      this.$nextTick(() => this.$refs.form.validate());
    },
    /**
     * シークレットコード更新(表示地区)API実行処理
     */
    APP_CU4303: function () {
      let param = '/api/emergencyContactFamilyMembers/updateSecretCodeDisplayDistrict';
      let method = 'post';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        secretCodeInfo: {
          secretCode: this.secretCode,
          secretCodeKana: this.secretCodeKana,
        },
        modified: this.modified,
      };
      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            this.$informationDialog(
              '$vuetify.FECU43緊急連絡先設定画面同居家族情報.登録が完了しました',
              true
            );
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * シークレットコード更新(カメラ)API実行処理
     */
    APP_CU4304: function () {
      let param = '/api/emergencyContactFamilyMembers/updateSecretCodeCamera';
      let method = 'post';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
        secretCodeInfo: {
          secretCode: this.secretCode,
          secretCodeKana: this.secretCodeKana,
        },
        modified: this.modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            this.$informationDialog(
              '$vuetify.FECU43緊急連絡先設定画面同居家族情報.登録が完了しました',
              true
            );
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 同居家族情報更新(表示地区)API実行処理
     * @param {Number} processType 処理区分
     */
    APP_CU4305: function (processType) {
      let param = '/api/emergencyContactFamilyMembers/updateContactInfoDisplayDistrict';
      let method = 'post';
      let message = '';
      const familyMembersInfo = this.createFamilyMembersInfo(processType);

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        familyMembersInfo: familyMembersInfo,
        modified: this.modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            switch (processType) {
              case CONSTANTS.PROCESS_TYPE.ADD:
              case CONSTANTS.PROCESS_TYPE.CHANGE:
                message = '$vuetify.FECU43緊急連絡先設定画面同居家族情報.登録が完了しました';
                break;
              case CONSTANTS.PROCESS_TYPE.DELETE:
                message = '$vuetify.FECU43緊急連絡先設定画面同居家族情報.削除が完了しました';
                break;
              case CONSTANTS.PROCESS_TYPE.SORT:
                message = '$vuetify.FECU43緊急連絡先設定画面同居家族情報.並び順が適用されました';
                break;
              default:
                break;
            }
            this.$informationDialog(message, true);
          },
          (error) => {
            if (error.message.includes('400')) {
              switch (processType) {
                case CONSTANTS.PROCESS_TYPE.ADD:
                  message = '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0016';
                  break;
                case CONSTANTS.PROCESS_TYPE.CHANGE:
                  message = '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0015';
                  break;
                case CONSTANTS.PROCESS_TYPE.DELETE:
                  message = '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0017';
                  break;
                case CONSTANTS.PROCESS_TYPE.SORT:
                  message = '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0021';
                  break;
                default:
                  break;
              }
              this.$errorDialog(message);
            } else {
              this.$_abnormality(error.response.status);
            }
            this.copyFamily = this.family;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 同居家族情報更新(カメラ)API実行処理
     * @param {Number} processType 処理区分
     */
    APP_CU4306: function (processType) {
      let param = '/api/emergencyContactFamilyMembers/updateContactInfoCamera';
      let method = 'post';
      let message = '';
      const familyMembersInfo = this.createFamilyMembersInfo(processType);

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
        familyMembersInfo: familyMembersInfo,
        modified: this.modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            switch (processType) {
              case CONSTANTS.PROCESS_TYPE.ADD:
              case CONSTANTS.PROCESS_TYPE.CHANGE:
                message = '$vuetify.FECU43緊急連絡先設定画面同居家族情報.登録が完了しました';
                break;
              case CONSTANTS.PROCESS_TYPE.DELETE:
                message = '$vuetify.FECU43緊急連絡先設定画面同居家族情報.削除が完了しました';
                break;
              case CONSTANTS.PROCESS_TYPE.SORT:
                message = '$vuetify.FECU43緊急連絡先設定画面同居家族情報.並び順が適用されました';
                break;
              default:
                break;
            }
            this.$informationDialog(message, true);
          },
          (error) => {
            if (error.message.includes('400')) {
              switch (processType) {
                case CONSTANTS.PROCESS_TYPE.ADD:
                  message = '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0016';
                  break;
                case CONSTANTS.PROCESS_TYPE.CHANGE:
                  message = '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0015';
                  break;
                case CONSTANTS.PROCESS_TYPE.DELETE:
                  message = '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0017';
                  break;
                case CONSTANTS.PROCESS_TYPE.SORT:
                  message = '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0021';
                  break;
                default:
                  break;
              }
              this.$errorDialog(message);
            } else {
              this.$_abnormality(error.response.status);
            }
            this.copyFamily = this.family;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 同居家族リストの件数確認・マッピング
     * @param {Array} familyMembersList 同居家族リスト
     */
    checkFamilyMembersList(familyMembersList) {
      if (familyMembersList.length === 0) {
        // データが存在しない場合、同居家族情報未登録ダイアログを表示する
        this.$informationDialog(
          '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0019'
        );
      } else {
        // 1件以上ある場合、マッピング
        familyMembersList.forEach((familyMember, idx) => {
          this.family.push({
            id: idx + 1,
            name: familyMember.familyMembersName,
            nameKana: familyMember.familyMembersKanaName,
            relationship: familyMember.familyMembersRelationship,
            relationshipOther: familyMember.familyMembersRelationshipOther,
            birthday: familyMember.familyMembersBirthdate,
          });
          this.copyFamily.push({
            id: idx + 1,
            name: familyMember.familyMembersName,
            nameKana: familyMember.familyMembersKanaName,
            relationship: familyMember.familyMembersRelationship,
            relationshipOther: familyMember.familyMembersRelationshipOther,
            birthday: familyMember.familyMembersBirthdate,
          });
          this.setFamily.push({
            id: idx + 1,
            name: familyMember.familyMembersName,
            nameKana: familyMember.familyMembersKanaName,
            relationship: familyMember.familyMembersRelationship,
            relationshipOther: familyMember.familyMembersRelationshipOther,
            birthday: familyMember.familyMembersBirthdate,
          });
        });
      }
    },
    /**
     * 登録する同居家族リストを作成
     * @param {Number} processType 処理区分
     * @returns 同居家族リスト
     */
    createFamilyMembersInfo: function (processType) {
      let familyList = [];
      switch (processType) {
        case CONSTANTS.PROCESS_TYPE.ADD:
          this.copyFamily.forEach((person) => {
            familyList.push({
              familyMembersName: person.name,
              familyMembersKanaName: person.nameKana,
              familyMembersRelationship: person.relationship === '' ? null : person.relationship,
              familyMembersRelationshipOther: person.relationshipOther ?? '',
              familyMembersBirthdate: person.birthday === '' ? null : person.birthday,
            });
          });
          break;
        case CONSTANTS.PROCESS_TYPE.CHANGE:
          this.copyFamily.forEach((person, idx) => {
            if (person === undefined) {
              familyList.push({
                familyMembersName: this.copyFamily[idx].name,
                familyMembersKanaName: this.copyFamily[idx].nameKana,
                familyMembersRelationship: this.copyFamily[idx].relationship,
                familyMembersRelationshipOther: this.copyFamily[idx].relationshipOther,
                familyMembersBirthdate: this.copyFamily[idx].birthday,
              });
            } else {
              familyList.push({
                familyMembersName: person.name,
                familyMembersKanaName: person.nameKana,
                familyMembersRelationship: person.relationship === '' ? null : person.relationship,
                familyMembersRelationshipOther: person.relationshipOther ?? '',
                familyMembersBirthdate: person.birthday === '' ? null : person.birthday,
              });
            }
          });
          break;
        case CONSTANTS.PROCESS_TYPE.DELETE:
          this.copyFamily.forEach((person) => {
            familyList.push({
              familyMembersName: person.name,
              familyMembersKanaName: person.nameKana,
              familyMembersRelationship: person.relationship === '' ? null : person.relationship,
              familyMembersRelationshipOther: person.relationshipOther ?? '',
              familyMembersBirthdate: person.birthday === '' ? null : person.birthday,
            });
          });
          break;
        case CONSTANTS.PROCESS_TYPE.SORT:
          this.setFamily.forEach((person, idx) => {
            familyList.push({
              familyMembersName: this.setFamily[idx].name,
              familyMembersKanaName: this.setFamily[idx].nameKana,
              familyMembersRelationship: this.setFamily[idx].relationship,
              familyMembersRelationshipOther: this.setFamily[idx].relationshipOther,
              familyMembersBirthdate: this.setFamily[idx].birthday,
            });
          });
          break;
        default:
          break;
      }

      // APIのリクエストは配列の大きさが7で固定なため、残りを空で埋める
      const emptyFamilyMember = {
        familyMembersName: '',
        familyMembersKanaName: '',
        familyMembersRelationship: null,
        familyMembersRelationshipOther: '',
        familyMembersBirthdate: null,
      };
      for (; familyList.length < CONSTANTS.REGISTRATION_LIMIT.FAMILY_MEMBERS_INFORMATION; ) {
        familyList.push(emptyFamilyMember);
      }

      return familyList;
    },
    /**
     * 登録確認ダイアログ呼び出し処理
     * @param {Number} processType 処理区分
     * @param {*} newPerson 同居家族情報
     */
    async callSaveAgreementDialogDialog(processType, newPerson) {
      // 同居家族のコピーを作成
      const copyFamily = this.copyFamily.map((obj) => {
        return obj;
      });
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.agreementDialog.入力された内容で登録します',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result) {
        this.$_setLoading(true);
        if (processType === 0) {
          if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
            this.APP_CU4303();
          } else {
            this.APP_CU4304();
          }
        } else {
          if (processType === CONSTANTS.PROCESS_TYPE.ADD) {
            this.copyFamily = [...this.copyFamily, newPerson];
          } else if (processType === CONSTANTS.PROCESS_TYPE.CHANGE && !!newPerson) {
            const index = this.copyFamily.findIndex((person) => person.id == newPerson.id);
            this.copyFamily[index] = newPerson;
          }
          // 遷移元の画面によって、APP_CU4305かAPP_CU4306のどちらかを実行
          if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
            this.APP_CU4305(processType);
          } else {
            this.APP_CU4306(processType);
          }
        }
      } else {
        // いいえボタンを押した場合、同居家族を元々のものに変更
        this.family = copyFamily;
      }
    },
    /**
     * シークレットコード変更ダイアログ登録ボタン押下時処理
     */
    validate() {
      if (this.$refs.form.validate()) {
        this.callSaveAgreementDialogDialog(0);
      }
    },
    /**
     * 並び替えボタン押下時処理
     */
    startSortFamily() {
      this.sortFlag = true;
      this.$emit('set-is-editing', true);
    },
    /**
     * 並び替え適用ボタン押下時処理
     */
    completeSortFamily() {
      this.$_setLoading(true);
      // 遷移元の画面によって、APP_CU4305かAPP_CU4306のどちらかを実行
      if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
        this.APP_CU4305(CONSTANTS.PROCESS_TYPE.SORT);
      } else {
        this.APP_CU4306(CONSTANTS.PROCESS_TYPE.SORT);
      }
    },
    /**
     * 並び替えをdataに反映させる処理
     */
    onEnd(event) {
      // https://github.com/SortableJS/Sortable#event-object-demo
      let copyPerson = {};
      const copyFamily = this.setFamily.map((obj) => {
        return obj;
      });

      switch (Math.sign(event.oldIndex - event.newIndex)) {
        case -1:
          // 前から後ろに入れ替え
          Object.assign(copyPerson, this.setFamily[event.oldIndex]);
          copyFamily.splice(event.oldIndex, 1);
          copyFamily.splice(event.newIndex, 0, copyPerson);
          break;
        case 1:
          // 後ろから前に入れ替え
          Object.assign(copyPerson, this.setFamily[event.oldIndex]);
          copyFamily.splice(event.oldIndex, 1);
          copyFamily.splice(event.newIndex, 0, copyPerson);
          break;
        default:
          break;
      }
      this.setFamily = copyFamily;
    },
    /**
     * 同居家族追加ダイアログ登録ボタン押下時処理
     * @param {*} person 同居家族
     */
    addPerson(person) {
      person.id = this.family.length + 1;
      this.callSaveAgreementDialogDialog(CONSTANTS.PROCESS_TYPE.ADD, person);
    },
    /**
     * 同居家族変更ダイアログ登録ボタン押下時処理
     * @param {*} newPerson 同居家族
     */
    editPerson(newPerson) {
      this.callSaveAgreementDialogDialog(CONSTANTS.PROCESS_TYPE.CHANGE, newPerson);
    },
    /**
     * 同居家族削除確認ダイアログはいボタン押下時処理
     * @param {*} id 同居家族インデックス
     */
    deletePerson(id) {
      this.$_setLoading(true);
      this.copyFamily = this.copyFamily.filter((person) => person.id !== id);
      // 遷移元の画面によって、APP_CU4305かAPP_CU4306のどちらかを実行
      if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
        this.APP_CU4305(CONSTANTS.PROCESS_TYPE.DELETE);
      } else {
        this.APP_CU4306(CONSTANTS.PROCESS_TYPE.DELETE);
      }
    },
    /**
     * 同居家族データ有無判定処理
     * @param {*} contact 同居家族
     * @returns データが有るかどうか
     */
    isExistFamilyMembers(contact) {
      if (
        (contact.name === '' || contact.name === null) &&
        (contact.nameKana === '' || contact.nameKana === null) &&
        (contact.relationship === '' || contact.relationship === null) &&
        (contact.relationshipOther === '' || contact.relationshipOther === null) &&
        (contact.birthday === '' ||
          contact.birthday === null ||
          isNaN(new Date(contact.birthday).getTime()))
      ) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * ラベル幅変更処理
     * @param {Number} width ラベル幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
};
